import { useAtom } from 'jotai';
import { useCallback, useEffect, useState } from 'react';

import { useAdditionalFieldsController } from 'api/controllers/AdditionalFieldsController';

import { Company, CurrencyDropDown } from 'openapi';

import { companyAtom } from 'state/state';

export const useCurrency = () => {
  const [company] = useAtom(companyAtom);
  const [currencies, setCurrencies] = useState<CurrencyDropDown[]>([]);
  const { getCurrencies } = useAdditionalFieldsController();

  useEffect(() => {
    const fetchCurrencies = async () => {
      try {
        const currencyData = await getCurrencies();
        setCurrencies(currencyData);
      } catch (error) {
        console.error('Failed to fetch currencies:', error);
      }
    };

    fetchCurrencies();
  }, [getCurrencies]);

  const getCurrencyCode = useCallback(
    (currencyId: number): string => {
      const currency = currencies.find((c) => c.id === currencyId);
      return currency?.isoCode || 'EUR';
    },
    [currencies]
  );

  const getCompanyCurrency = useCallback(
    (companyData?: Company): string => {
      if (!companyData?.currencyId) return 'EUR';
      return getCurrencyCode(companyData.currencyId);
    },
    [getCurrencyCode]
  );

  const getCurrentCompanyCurrency = useCallback((): string => {
    return getCompanyCurrency(company);
  }, [company, getCompanyCurrency]);

  return {
    currencies,
    getCurrencyCode,
    getCompanyCurrency,
    getCurrentCompanyCurrency
  };
};
